
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import FormWrapper from '@/core/wrappers/form-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import SelectBox, { SelectBoxTypes } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { CheckBox, DataGrid, Popup, TextBox } from 'devextreme-react';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { useAuth } from '@/modules/auth';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { format } from 'path';
import { toast } from 'react-toastify';
import { alert, confirm } from 'devextreme/ui/dialog';
import {
    Validator,
    RequiredRule,
} from 'devextreme-react/validator';
import { boolean, number, string } from 'yup';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { parseNumber } from 'devextreme/localization';
import { IOrderDetail, IVendorSupplyParameter } from '@/core/interfaces/usestate-interfaces';
import moment from 'moment';

import { Switch } from 'devextreme-react';

import DataSource from "devextreme/data/data_source";
import { CustomRule } from 'devextreme-react/validator';
import { Position, ToolbarItem } from 'devextreme-react/cjs/popup';
import { Alert } from 'react-bootstrap';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { left, right } from '@popperjs/core';
import ArrayStore from 'devextreme/data/array_store';
import { vendorService } from '../services/vendor_supply_parameter-service';
import { CheckBoxTypes } from 'devextreme-react/cjs/check-box';

function VendorSupplyDetail() {

    const [vendorSupplyData, setvendorSupplyData] = useState<IVendorSupplyParameter>();
    const [supplierLookup, setSupplierLookup] = useState([]);
    const [locationLookup, setLocationLookup] = useState([]);
    const [cuttOffLookup, setCuttOffLookup] = useState([]);
    const [isAdditionalOrder, setIsAdditionalOrder] = useState(false);
    const [store, setStore] = useState<CustomStore>();

    const dataGridRef = useRef<DataGrid>(null);
    const validatorRef = useRef<Validator>(null);


    useEffect(() => {
        if (vendorSupplyData == null) {
            const fetchAccounts = async () => {
                

                let param = "";
                if(params.id){
                    param = params.id;
                }
                else{
                    param="-1";
                }
                const data = await vendorService.getVendorSupplyParameter(param);

                setvendorSupplyData(data)

                setSupplierValue(data.vendorCode)
                setLocationValue(data.locationCode)
                setCutOffValue(data.cutOffTime)
                setIsAdditionalOrder(data.hasAdditionalOrder)
            };
            fetchAccounts();
        }
    }, [vendorSupplyData])


    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])


    const params = useParams();
    const onGetOrderData = useCallback(async () => { 
        getVendorGroups();
        getLocationUnits();
        //return vendorSupplyData?.orderDays

                let param = "";
                if(params.id){
                    param = params.id;
                }
                else{
                    param="-1";
                }

        const x = await vendorService.getVendorSupplyParameter(param);
        return x.orderDays;
    }, []);


    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const navigate = useNavigate();
    const goToBack = () => {
        navigate(`/syncflow/vendor_supply_parameter`)
    }


    const onSave = async () => {
        
        const orderDayValues = [];
        if (dataGridRef.current && dataGridRef.current.instance) {
            for (let i = 0; i <= dataGridRef.current?.instance.totalCount()-1; i++) {
                const orderDayValue = dataGridRef.current?.instance.cellValue(i, "isOrderDay");
                orderDayValues.push(orderDayValue);
            }
        }
        console.dir(orderDayValues);


        const deliveryDayValues = [];
        if (dataGridRef.current && dataGridRef.current.instance) {
            for (let i = 0; i <= dataGridRef.current?.instance.totalCount()-1; i++) {
                const deliveryDayValue = dataGridRef.current?.instance.cellValue(i, "deliveryDay");
                deliveryDayValues.push(deliveryDayValue);
            }
        }
        console.dir(deliveryDayValues);

        console.log(supplierValue);
        //return false;
        
        const vendorSupplyParamsObject = {
            cutoffTime: cuttOffValue,
            deliveryDay01: deliveryDayValues[0],
            deliveryDay02: deliveryDayValues[1],
            deliveryDay03: deliveryDayValues[2],
            deliveryDay04: deliveryDayValues[3],
            deliveryDay05: deliveryDayValues[4],
            deliveryDay06: deliveryDayValues[5],
            deliveryDay07: deliveryDayValues[6],
            hasAdditionalOrder: isAdditionalOrder,
            id: params.id,
            isOrderDay01: orderDayValues[0],
            isOrderDay02: orderDayValues[1],
            isOrderDay03: orderDayValues[2],
            isOrderDay04: orderDayValues[3],
            isOrderDay05: orderDayValues[4],
            isOrderDay06: orderDayValues[5],
            isOrderDay07: orderDayValues[6],
            locationCode: locationValue,
            orderDays: [
              { id: 1, isOrderDay: orderDayValues[0], deliveryDay: deliveryDayValues[0] },
              { id: 2, isOrderDay: orderDayValues[1], deliveryDay: deliveryDayValues[1] },
              { id: 3, isOrderDay: orderDayValues[2], deliveryDay: deliveryDayValues[2] },
              { id: 4, isOrderDay: orderDayValues[3], deliveryDay: deliveryDayValues[3] },
              { id: 5, isOrderDay: orderDayValues[4], deliveryDay: deliveryDayValues[4] },
              { id: 6, isOrderDay: orderDayValues[5], deliveryDay: deliveryDayValues[5] },
              { id: 7, isOrderDay: orderDayValues[6], deliveryDay: deliveryDayValues[6] },
            ],
            vendorCode: supplierValue,
        };


        let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {

                    if (params.id) {
                        vendorService.updateVendorSupplyParameter(null, vendorSupplyParamsObject);
                        //navigate(`/syncflow/vendor_supply_parameter`, {});
                    }
                    else {
                        console.log("ADD");
                        vendorSupplyParamsObject.id="";
                        vendorService.createVendorSupplyParameter(vendorSupplyParamsObject);
                        //navigate(`/syncflow/vendor_supply_parameter`, {});
            
                    }

                    toast.success(t("syncflow:msg_saved"));

                }
            });


        

        
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            vendorService.createVendorSupplyParameter(e.changes).then((response) => {
                toast.success(t("syncflow:msg_saved"));
            });
        }
        else {
            
        }
    }

    const getVendorGroups = async () => {
        setSupplierLookup(await vendorService.getSuppliers());
    }

    const getLocationUnits = async () => {
        setLocationLookup(await vendorService.getLocations());
    }

    const cutOffs = [
        { "id": "00:00:00", "name": "00:00:00" },
        { "id": "01:00:00", "name": "01:00:00" },
        { "id": "02:00:00", "name": "02:00:00" },
        { "id": "03:00:00", "name": "03:00:00" },
        { "id": "04:00:00", "name": "04:00:00" },
        { "id": "05:00:00", "name": "05:00:00" },
        { "id": "06:00:00", "name": "06:00:00" },
        { "id": "07:00:00", "name": "07:00:00" },
        { "id": "08:00:00", "name": "08:00:00" },
        { "id": "09:00:00", "name": "09:00:00" },
        { "id": "10:00:00", "name": "10:00:00" },
        { "id": "11:00:00", "name": "11:00:00" },
        { "id": "12:00:00", "name": "12:00:00" },
        { "id": "13:00:00", "name": "13:00:00" },
        { "id": "14:00:00", "name": "14:00:00" },
        { "id": "15:00:00", "name": "15:00:00" },
        { "id": "16:00:00", "name": "16:00:00" },
        { "id": "17:00:00", "name": "17:00:00" },
        { "id": "18:00:00", "name": "18:00:00" },
        { "id": "19:00:00", "name": "19:00:00" },
        { "id": "20:00:00", "name": "20:00:00" },
        { "id": "21:00:00", "name": "21:00:00" },
        { "id": "22:00:00", "name": "22:00:00" },
        { "id": "23:00:00", "name": "23:00:00" }
      ];


    const [supplierValue, setSupplierValue] = useState(supplierLookup);
    const onValueChangedSupplier = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setSupplierValue(e.value);
    }, []);

    const [locationValue, setLocationValue] = useState(locationLookup);
    const onValueChangedLocation = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setLocationValue(e.value);
    }, []);

    const [cuttOffValue, setCutOffValue] = useState(cuttOffLookup);
    const onValueChangedCuttOff = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setCutOffValue(e.value);
    }, []);


    const onValueChangedHas = useCallback((e: CheckBoxTypes.ValueChangedEvent) => {
        setIsAdditionalOrder(e.value);
    }, []);


    return (
        <>

            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_back")}
                            type="default"
                            icon="back"
                            stylingMode="contained"
                            onClick={goToBack}
                        />
                    </div>
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                    />
                </div>

            </div>



            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:supplier")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="supplierLookup"
                                dataSource={supplierLookup}
                                value={supplierValue}
                                onValueChanged={onValueChangedSupplier}
                                valueExpr="id"
                                displayExpr="name"
                                showClearButton={true}>
                                <Validator ref={validatorRef}>
                                    <RequiredRule message="Confirm Store is required" />
                                </Validator>
                            </SelectBox>
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:location")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="locationsLookups"
                                dataSource={locationLookup}
                                value={locationValue}
                                onValueChanged={onValueChangedLocation}
                                valueExpr="id"
                                displayExpr="name"
                                showClearButton={true}>
                                <Validator ref={validatorRef}>
                                    <RequiredRule message="Confirm Store is required" />
                                </Validator>
                            </SelectBox>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_cut_off")}</label>
                <div className="col-lg-3">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="cutOffsLookups"
                                dataSource={cutOffs}
                                value={cuttOffValue}
                                onValueChanged={onValueChangedCuttOff}
                                valueExpr="id"
                                displayExpr="name"
                                showClearButton={true} />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">{t('syncflow:has_additional_order')}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <CheckBox value={isAdditionalOrder} onValueChanged={onValueChangedHas}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    columnChooser={true}
                    remoteOperations={false}
                    showColumnLines={true}
                    onSaving={onSaving}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'id',
                            caption: "Days",
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return t('syncflow:delivery_0' + data.data.id)
                            },
                        },
                        {
                            dataField: 'isOrderDay',
                            caption: "Is Order Day",
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'deliveryDay',
                            caption: "Delivery Day",
                            allowFiltering: true,
                            allowEditing: true,
                        }

                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default VendorSupplyDetail
